module.exports = __webpack_public_path__ + "static/media/cb-icon-mobile.d3419e79.svg";